// Auto-generated skeleton for ReportSubType

import { ReportType } from "./ReportType";
import { Role } from "./Role";

export const ReportSubType: Api.ReportSubType = {
  id: 0,
  name: '',
  description: '',
  document_required: false,
  location_required: false,
  default_to_craftsman_task: false,
  report_type_id: 0,
  role_id: 0,
  report_type: ReportType,
  role: Role,
};

